import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ConceptPage = lazy(() => import('../pages/concept/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const ProductWakasa2Page = lazy(() => import('../pages/product-wakasa2/page'));
const ProductWakasa3Page = lazy(() => import('../pages/product-wakasa3/page'));
const ProductWakasa4Page = lazy(() => import('../pages/product-wakasa4/page'));
const ProductWakasa5Page = lazy(() => import('../pages/product-wakasa5/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const PickupStorePage = lazy(() => import('../pages/pickup-store/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/concept',
    element: <ConceptPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/product',
    element: <ProductPage />,
  },
  {
    path: '/product-wakasa2',
    element: <ProductWakasa2Page />,
  },
  {
    path: '/product-wakasa3',
    element: <ProductWakasa3Page />,
  },
  {
    path: '/product-wakasa4',
    element: <ProductWakasa4Page />,
  },
  {
    path: '/product-wakasa5',
    element: <ProductWakasa5Page />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/pickup-store',
    element: <PickupStorePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
